import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchRemoveResourceFromProject = async (projectId, resourceId) => {
  const apiPath = `resources/project/${projectId}/resource/${resourceId}/remove-resource-from-project`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: {},
  });

  const response = await axios(signedRequest);

  return response.data;
};
